
export default {
  name: 'BaseContentBlockListItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  methods: {
    cleanNbsp(text) {
      let newText = text

      const re = /<a\s+href=/gi
      // const subst = this.isBusiness
      //   ? '<a target="_blank" rel="noopener dofollow" href='
      //   : '<a target="_blank" rel="noopener noreferrer nofollow" href='
      const subst =
        '<a target="_blank" rel="noopener noreferrer nofollow" href='
      newText = newText?.replace(re, subst)
      newText = newText?.replace(/&nbsp;/g, ' ').trim()
      return newText
    },
  },
}
